import { FC } from 'react';
import { SecondaryTextTypography } from '../../../../../App.styles';
import { Icon, Icons, Tooltip, Typography } from '../../../../../stories/atoms';
import {
  ColumnFlexContainer,
  ContainerV2,
  RowFlexContainer,
} from '../../../../../stories/atoms/containerV2/ContainerV2';
import { Colors, muiTheme, percentToHex } from '../../../../../theme';

type OrderBreakdownItemProps = {
  icon: Icons;
  text: string;
  iconColor: Colors;
  count: number;
  totalCount: number;
  tooltipText: string;
};

export const OrderBreakdownItem: FC<OrderBreakdownItemProps> = ({
  icon,
  text,
  iconColor,
  count,
  totalCount,
  tooltipText,
}) => {
  const percentValue = (totalCount === 0 ? 0 : count / totalCount) * 100;
  const roundedPercentValue = Math.round(percentValue);

  return (
    <ColumnFlexContainer
      padding={[2.5, 4]}
      style={{
        backgroundColor: percentToHex(muiTheme.color[iconColor], 8),
      }}
      borderRadius={[2]}
    >
      <RowFlexContainer>
        <RowFlexContainer flex={1} alignItems="center" gap={[2]}>
          <Icon icon={icon} size="small" color={iconColor} />
          <Typography type="body3">{text}</Typography>
          <Tooltip
            text={
              <Typography type="caption" color="white">
                {tooltipText}
              </Typography>
            }
            position="bottom"
            arrowedToolTip
          >
            <Icon icon={Icons.INFO} size="small" />
          </Tooltip>
        </RowFlexContainer>

        <RowFlexContainer gap={[2]} alignItems="center">
          <Typography type="body3">{count.toLocaleString()}</Typography>

          <ContainerV2 display="flex" alignItems="center" justifyContent="center" width={[8]} height={[5]}>
            <SecondaryTextTypography type="caption">{roundedPercentValue}%</SecondaryTextTypography>
          </ContainerV2>
        </RowFlexContainer>
      </RowFlexContainer>{' '}
    </ColumnFlexContainer>
  );
};
